export class UserToken {
  username: string = undefined;
  iat: Date;
  exp: Date;
  roles: Array<string>;
  brutToken: string;
  id: number;

  constructor(brutToken: string, id: number) {
    try {
      let parsed = JSON.parse(atob(brutToken.split(".")[1]));
      this.brutToken = brutToken;
      this.username = parsed.username;
      this.iat = new Date(parsed.iat * 1000);
      this.exp = new Date(parsed.exp * 1000);
      this.roles = Object.values(parsed.roles);
    } catch (e) {

    }
    this.id = id;    
  }

  isLoggedIn(): boolean {
    return this.username !== undefined;
  }
}
